<template>
  <v-container fluid class="main info--text">
    <v-row>
      <v-col>
        <v-container fluid :style="!$vuetify.breakpoint.smAndDown ? 'margin-left: 1cm; margin-top: 2cm;' : ''">
          <v-row no-gutters>
            <v-col>
              <p class="head1">Solve waste <br v-if="!$vuetify.breakpoint.smAndDown"/> removal hassles.</p>
              <br/>
              <h2 style="font-family: Avenir1;" class="primary--text">Get an instant quote, book in seconds</h2>
              <br/>
            </v-col>
          </v-row>   
        </v-container>
        <FastQuote class="fastQuote par" :style="$vuetify.breakpoint.smAndDown ? 'margin-left: -0.2cm;' : 'margin-left: 0.6cm;'"/>
      </v-col>
      <v-col style="margin-top: 2cm;" v-if="!$vuetify.breakpoint.smAndDown" cols="6" align="left">
        <v-img contain src="@/assets/Group1.png"></v-img>
      </v-col>
    </v-row>
    <v-row v-if="$vuetify.breakpoint.smAndDown" justify="center" align="left">
      <v-img cover src="@/assets/Group2.png"></v-img>
    </v-row>
    <v-row>
      <v-col align="center">
        <h2 class="primary--text mt-10" style="font-family: Avenir1;">Waste removal made simple</h2> <br/> 
        <p class="headers1"> Get sorted in 3 simple steps  </p>
      </v-col>
    </v-row>
    <br/>
    <v-row class="mt-5" justify="center">
      <v-col align="center">
        <v-img width="450" contain src="@/assets/InstantBook.svg"></v-img>
      </v-col>
      <v-col align="center">
        <v-img width="450" contain src="@/assets/Fulfillment.svg"></v-img>
      </v-col>
      <v-col align="center">
        <v-img width="450" contain src="@/assets/BookPay.svg"></v-img>
      </v-col>
    </v-row>
    <v-row style="background-image: linear-gradient(to right, white, #E57373);" class="px-4">
      <v-col md="6" class="mt-10">
        <v-row>
          <v-col>
            <p class="info--text headers2">Get instant service with our fully online booking system</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <p class="info--text par">Waste Dash allows you to book a variety of waste removal services in just a few clicks. </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 
              @click="check1()" 
              :style="show1 ? 'cursor: context-menu; font-family: Avenir1;' : 'cursor: pointer; font-family: Avenir1;'" 
              :class="show1 ? 'primary--text' : 'info--text'"
            >
              <ul>
                <li :class="show1 ? 'primary--text' : 'info--text'">
                  Instant Booking
                  <v-icon :class="show1 ? 'primary--text' : 'info--text'"> {{ show1 ? 'mdi-arrow-bottom-right' : 'mdi-arrow-right' }} </v-icon> 
                </li>
              </ul>
            </h2>
            <br/>
            <p v-if="show1" class="info--text ml-6 par">
              Our automated booking system will instantly match you with the best available 
              services to suite your requirements, all done through our dashboard.
            </p>
            <v-img v-if="show1 && $vuetify.breakpoint.smAndDown" contain src="@/assets/Phone1.svg"></v-img>
            <br v-if="show1"/>
  
            <h2 
              @click="check2()" 
              :style="show2 ? 'cursor: context-menu; font-family: Avenir1;' : 'cursor: pointer; font-family: Avenir1;'"
              :class="show2 ? 'primary--text' : 'info--text'"
            > 
              <ul>
                <li :class="show2 ? 'primary--text' : 'info--text'">
                  Real-time Service Provider Tracking 
                  <v-icon :class="show2 ? 'primary--text' : 'info--text'">{{ show2 ? 'mdi-arrow-bottom-right' : 'mdi-arrow-right' }}</v-icon>
                </li>
              </ul>
            </h2>
            <br/>
            <p v-if="show2" class="info--text ml-6 par">
              You will be instantly matched with one of our trusted approved service providers, with 
              the ability to track their location both before and after collecting your waste.
            </p>
            <v-img v-if="show2 && $vuetify.breakpoint.smAndDown" contain src="@/assets/Phone2.svg"> </v-img>
            <br v-if="show2 "/>
  
            <h2 
              @click="check3()" 
              :style="show3 ? 'cursor: context-menu; font-family: Avenir1;' : 'cursor: pointer; font-family: Avenir1;'" 
              :class="show3 ? 'primary--text' : 'main--text'"
            > 
              <ul>
                <li :class="show3 ? 'primary--text' : 'info--text'">
                  Booking Management Dashboard 
                  <v-icon :class="show3 ? 'primary--text' : 'info--text'">{{ show3 ? 'mdi-arrow-bottom-right' : 'mdi-arrow-right' }}</v-icon>
                </li>
              </ul> 
            </h2>
            <br/>
            <p v-if="show3" class="info--text ml-6 par">
              Our hassle-free booking management dashboard gives you a bird's eye view of
              all of your bookings, both past and present.
            </p>
            <v-img v-if="show3 && $vuetify.breakpoint.smAndDown" contain src="@/assets/Phone3.svg"></v-img>
          </v-col>
        </v-row>
      </v-col>
      <v-col align="right" v-if="!$vuetify.breakpoint.smAndDown" class="mt-12" cols="6">
        <v-img v-if="show1" align="right" style="margin-left: 2cm;" contain src="@/assets/Phone1.svg"/> 
        <v-img v-if="show2" align="right" style="margin-left: 2cm;" contain src="@/assets/Phone2.svg"/>
        <v-img v-if="show3" align="right" style="margin-left: 2cm;" contain src="@/assets/Phone3.svg"/>
      </v-col>
    </v-row>
    <br/>
  
    <v-row justify="center" class="mt-10">
      <v-col align="center">
          <h2 class="primary--text" style="font-family: Avenir1;">What we do</h2> <br/> 
          <p class="headers1"> Why choose us </p>
          <br/>
          <benefits/>
        </v-col>
    </v-row>
    <br/>
  
    <v-row class="mt-10">
      <v-col align="center">
        <h2 class="primary--text" style="font-family: Avenir1;">We’re constantly expanding our reach</h2> <br/>
        <p :class="$vuetify.breakpoint.smAndDown ? 'headers2 text-start' :'headers2'"> 
          Our service area is constantly growing, here 
          <br v-if="!$vuetify.breakpoint.smAndDown"/>
          are the areas where Waste Dash is currently available 
        </p>
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mt-10">
      <v-col align="center" md="8">
        <v-img contain src="@/assets/map.svg"/>
      </v-col>
    </v-row>
  
    <v-row style="background-image: linear-gradient(to right, white, #E57373);" class="px-4" id="testimonials">
      <v-row>
          <v-col>
            <h2 class="primary--text mt-12" style="font-family: Avenir1;">Client Testimonials</h2>
            <br/>
            <p class="info--text headers2">
              What clients are saying
            </p>
            <br/>
        </v-col>
      </v-row>
      <WhatClientThink/>
    </v-row>
    <br/>
  
    <v-row justify="center" class="mt-10" :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
      <v-col md="4">
        <v-row>
          <v-col align="start">
            <h2 class="primary--text" style="font-family: Avenir1;">Have questions?</h2> <br/>
            <p class="headers2"> Frequently Asked Questions </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="par">
            <p class="info--text">
              We pride ourselves on transparency and great customer service, which is why no questions go unanswered.
            </p>
            <br/>
            <p>
              <span style="font-weight: bold; font-size: 16px;"> Have more questions? Call Us </span>
              <a class="primary--text" href="tel:+27722459777" style="text-decoration: none;"> 072 245 9777</a>
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col align="right" md="6" class="par">
        <v-row justify="right">
          <v-col>
            <v-expansion-panels dark popout>
            <v-expansion-panel style="border-radius: 20px;">
              <v-expansion-panel-header 
                color="info main--text" 
                style="font-family: Avenir3; font-style: normal; font-weight: 400; font-size: 20px; line-height: 20px; height: 80px;"
                >
                How to book?
              </v-expansion-panel-header>
              <v-expansion-panel-content color="main info--text">
                <v-row justify="center">
                  <v-col align="start">
                    <ul class="info--text mt-5">
                        <li> Sign up in 60 seconds with your card or EFT. </li>
                        <li> Enter your waste location. </li>
                        <li> Book different waste types & various products for multiple locations on your dashboard. </li>
                    </ul>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row justify="right">
          <v-col>
            <v-expansion-panels dark popout>
            <v-expansion-panel style="border-radius: 20px;">
              <v-expansion-panel-header 
                color="info main--text" 
                style="font-family: Avenir3; font-style: normal; font-weight: 400; font-size: 20px; line-height: 20px; height: 80px;"
                >
                How does Waste Dash work?
              </v-expansion-panel-header>
              <v-expansion-panel-content color="main info--text">
                <br/>
                <HowItWorks/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row justify="right">
          <v-col>
            <v-expansion-panels dark popout>
            <v-expansion-panel style="border-radius: 20px;">
              <v-expansion-panel-header 
                color="info main--text" 
                style="font-family: Avenir3; font-style: normal; font-weight: 400; font-size: 20px; line-height: 20px; height: 80px;"
                >
                How do I pay?
              </v-expansion-panel-header>
              <v-expansion-panel-content color="main secondary--text">
                <Payment/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row justify="right">
          <v-col align="center">
            <router-link style="text-decoration: none;" class="white--text" to="/help">
              <button 
                style="width: 200px; height: 10px; border-radius: 15px; font-family: Avenir3; font-style: normal; font-weight: 400; font-size: 20px; line-height: 20px; height: 80px;"
               class="info main--text">More  FAQS</button>
            </router-link>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <br/> <br/><br/> <br/>
  
    <v-row justify="center" class="primary px-4" :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''" id="installApp">
      <v-col v-if="$vuetify.breakpoint.smAndDown" class="mt-10">
        <v-img style="margin-top: -3cm;" contain src="@/assets/Devices.svg"/>
      </v-col>
      <v-col align="center" v-if="!$vuetify.breakpoint.smAndDown">
        <v-img class="mt-12" src="@/assets/Devices.svg"/>
      </v-col>
    </v-row>
  </v-container>
  </template>
  
  <script>
  
  import FastQuote from "@/components/fast-quote/FastQuote";
  import WhatClientThink from "@/components/WhatClientThink";
  import benefits from "@/components/benefits";
  import Payment from "@/components/payment";
  import HowItWorks from "@/components/howItWorks";
  
  export default {
    name: 'Homepage',
    components: {
      FastQuote,
      benefits,
      WhatClientThink,
      Payment,
      HowItWorks
    },
    data (){
      return{
        show1: true,
        show2: false,
        show3: false
      }
    },
    methods: {
      check1(){
        this.show1 = true;
        this.show2 = false;
        this.show3 = false;
      },
      check2(){
        this.show2 = true;
        this.show1 = false;
        this.show3 = false
      },
      check3(){
        this.show3 = true;
        this.show1 = false;
        this.show2 = false;
      },
      redirect(){
        window.location.href = 'https://app.dashwaste.co.za/signup';
      },
      redirectLogin(){
        window.location.href = 'https://app.dashwaste.co.za/login';
      }
    },
    mounted(){
      scrollTo(0, 0);
    }
  }
  
  </script>
  
  <style scoped>
  .head1{
    font-family: Avenir1;
    font-style: normal;
    font-weight: 750px;
    font-size: 56px;
    line-height: 64px;
  }
  .headers1{
    font-family: Avenir1;
    font-style: normal;
    font-weight: 750;
    font-size: 48px;
    line-height: 64px;
  }
  .headers2{
    font-family: Avenir1;
    font-style: normal;
    font-weight: 750;
    font-size: 48px;
    line-height: 64px;
  }
  .par{
    font-family: Avenir3;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
  }
  .footer{
    font-family: Avenir3;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
  }
  .fastQuote{
    margin-top: -0.6cm;
  }
  #img1{
    background-image: url("/driver.png");
    background-attachment: fixed;
    background-size: cover;
    background-position-y: center;
   
  }
  #img2{
    display: none;
  }
  .quote{
    background-image: url("/logo-mini.svg");
    background-attachment: scroll;
    background-size: contain;
    background-position: center;
  }
  .fastquote{
    background: rgba(248, 248, 247, 0.82); 
  }
  @media screen and (max-width: 850px){
    .card1{
      position: relative;
      left: -0cm;
    }
  
  }
  
  @media screen and (max-width: 580px){
    .row1{
      display: block;
    }
    #steps{
      display: block;
    }
    .step{
      display: block;
    }
    #img1{
      background-image: none;  
      margin: 0;
    }
    #img2{
      display: block;
      margin-top: -0.5cm;
      border-bottom-right-radius: 90px;
      border-top-left-radius: 90px; 
      position: relative;
      left: 0.3cm;
    }
    .card1{
      position: relative;
      top: 0.4cm;
      left: 0cm;
      max-width: 100%;
    }
    .card2{
      position: relative;
      left: 0.2cm;
    }
    .partners{
      display: block;
      margin-bottom: 14cm;
    }
    
  
  }
  
  </style>